export default __webpack_public_path__ + "static/media/junayna.1005fb46.jpg";